import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";
import { Options } from "./SelectOptions";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    salaryRequest: string,
    entranceDate: Date | null,
    researchAssistant: CheckboxField[],
    trainee: CheckboxField[],
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string = "";
    salaryRequest: string = "";
    entranceDate: Date | null = null;
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    researchAssistant: CheckboxField[] = Options.ResearchAssistant.map((field) => {
        return new CheckboxField(field.value);
    });
    trainee: CheckboxField[] = Options.Trainee.map((field) => {
        return new CheckboxField(field.value);
    });

    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation },
            { name: "salaryRequest", value: this.salaryRequest },
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
            { name: "researchAssistant", value: this.researchAssistant.filter((field) => field.value === true).map((field) => field.displayName).join(';')},
            { name: "trainee", value: this.trainee.filter((field) => field.value === true).map((field) => field.displayName).join(';')},
        );

        return application;
    }
}
